import { login, signup } from "/providers/auth-api"

const credentialsSignin = async ({ formData, apiSource, setApiKey, setUser, setClient }) => {
  return handler({ fn: login, formData, apiSource, setApiKey, setUser, setClient })
}

const credentialsSignup = async ({ formData, apiSource, setApiKey, setUser, setClient }) => {
  return handler({ fn: signup, formData, apiSource, setApiKey, setUser, setClient })
}

export { credentialsSignin, credentialsSignup }


const handler = async ({ fn, formData, apiSource, setApiKey, setUser, setClient }) => {

  const email = formData.get('email')
  const password = formData.get('password')
  const name = formData.get('name')

  let loginResponse = await fn({apiSource, email, password, name})

  if (loginResponse.authenticated) {
    setApiKey(loginResponse.key)
    setClient(loginResponse.client)
    setUser(loginResponse.user)
  } else {
    return { type: 'CredentialsSignin', error: loginResponse.error }
  }
}